import {SkuModel} from './sku.model';

export class SearchResponseModel {
  skuDtos: SkuModel[];
  measureId: number;
  evaluatedUniformMeasureId: boolean;
}
